import { ActionButtonCategory } from 'core/api';

// Los ponemos en hexadecimal para que desde la administración se puedan usar. El día que exista Chakra en la administración podemos cambiarlos

export const hexColorsByActionButtonCategory: Record<ActionButtonCategory, string> = {
	[ActionButtonCategory.TicketManagement_Operations]: '#5DB6FD', // blue.400
	[ActionButtonCategory.TicketManagement_Edition]: '#5DB6FD', // blue.400
	[ActionButtonCategory.TableManagement]: '#2BC669', // green.500
	[ActionButtonCategory.PrintingManagement]: '#0BCCEA', // cyan.400'
	[ActionButtonCategory.Queries_Documents]: '#0BCCEA', // cyan.400'
	[ActionButtonCategory.Queries_Ticket_And_Kitchen_Command]: '#0BCCEA', // cyan.400'
	[ActionButtonCategory.Queries_Products]: '#0BCCEA', // cyan.400'
	[ActionButtonCategory.CashOperations_CashMovements]: '#F0B514', // yellow.500
	[ActionButtonCategory.CashOperations_PaymentsAndCharges]: '#F0B514', // yellow.500
	[ActionButtonCategory.CashOperations_Refunds]: '#F0B514', // yellow.500
	[ActionButtonCategory.WarehouseAndStock]: '#BF7131', // amber.500
	[ActionButtonCategory.PromotionsAndLoyalty]: '#F76E89', // pink.400
	[ActionButtonCategory.DeliveryAndWebOrders]: '#F58851', // orange.400
	[ActionButtonCategory.CustomersAndReservations]: '#46BEBB', // teal.600
	[ActionButtonCategory.KitchenActions]: '#FD7C7C', // red.300
	[ActionButtonCategory.Admin_And_Utilities]: '#8E9BAF', // 'gray.400'
	[ActionButtonCategory.Custom]: '#B794F4', // purple.300
};